import React, {useState, useEffect, useCallback} from 'react';
import Toast from "../../Components/Toast";
import Header from "../../Layouts/Header";

import {MapContainer, Marker, TileLayer, Popup} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import MapMarker from "../../Assets/Images/mapMarker.png";
import {TbCheck} from "react-icons/tb";
import API from "../../Services/API";
import {toast} from "react-toastify";
import { useParams} from "react-router-dom";

let DefaultIcon = L.icon({
    iconUrl: MapMarker,
    iconSize: [20, 20],
});

L.Marker.prototype.options.icon = DefaultIcon;

const center = [36.32, 59.51]
const zoom = 13

function AddAddress(props) {
    const {id} = useParams();


    const [haveLocation, setHaveLocation] = React.useState(false);
    const [map, setMap] = React.useState(null);
    const [address, setAddress] = React.useState('');
    const [title, setTitle] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [position, setPosition] = useState(map ? map.getCenter() : {lat: 36.3136, lng: 59.5899})
    const [, setIsLoaded] = React.useState(false);


    function handleLocationClick() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, error);
        } else {
            console.log("Geolocation not supported");
        }
    }

    function success(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        setPosition({latitude, longitude});
        console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);

    }

    function error() {
        console.log("Unable to retrieve your location");
    }


    const onSetLocation = () => {
        setHaveLocation(true);
        /*       API.searchNeshanReverse(position.lat, position.lng)
                   .then((response) => {
                       setAddress(response.formatted_address)

                   })*/
    }

    const onSaveAddress = () => {
        const request = {
            title,
            address,
            lat: position.lat.toFixed(4),
            long: position.lng.toFixed(4),
            contact_phone : phone

        }

        API.updateAddress(id,request)
            .then((response) => {

                toast.success(response.message);
                setHaveLocation(false)
                setTimeout(() => {
                    // navigate('/cart');
                    window.history.back()
                }, 1500)
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    const onMove = useCallback(() => {
        setPosition(map.getCenter())
    }, [map])

    useEffect(() => {


        if (map) {
           // handleLocationClick()
            map.on('move', onMove)
            API.getAddress(id)
                .then((response) => {
                    setAddress(response.data.address.address);
                    setTitle(response.data.address.title)
                    setPhone(response.data.address.contact_phone)
                    setPosition({lat: parseInt(response.data.address.lat), lng: parseInt(response.data.address.long)})

                    map.panTo(new L.LatLng(parseInt(response.data.address.lat), parseInt(response.data.address.long)));

                    setIsLoaded(true);
                })
                .catch((error) => {
                    setIsLoaded(true);
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }

        return () => {
            if (map)
                map.off('move', onMove)
        }
    }, [map, onMove])


    return (
        <React.Fragment>
            <Toast/>

            <Header title='ویرایش آدرس' hasBack={true}/>
            {
                haveLocation &&
                <section className="container-fluid modal-bg max-w-lg">
                    <div className="row rtl overflow-scroll vh-100">
                        {/*
                        <div className="col-12 text-center">
                            <img src={`https://api.neshan.org/v2/static?key=service.f60fc93d90f247fc871d107834659638&type=dreamy&zoom=18&center=${position.lat.toFixed(4)},${position.lng.toFixed(4)}&width=${window.screen.width - 30}&height=200&marker=red`}
                            className='neshan-map max-w-lg ' alt='نمایش موقعیت انتخابی'
                            />
                        </div>*/}
                        <div className="col-12 form-floating mt-3">
                                                <textarea className="form-control"
                                                          placeholder="توضیحات"
                                                          id="floatingTextarea"
                                                          rows={8}
                                                          value={address}
                                                          onChange={(val) => {
                                                              setAddress(val.target.value)
                                                          }}
                                                >
                            </textarea>
                            <label htmlFor="floatingTextarea" className='text-small-2 right-0'>
                                آدرس دقیق
                            </label>
                        </div>
                        <div className="col-12 mt-3">
                            <div className="form-floating mb-3">
                                <input type="text"
                                       className="form-control"
                                       id="floatingInput"
                                       placeholder="عنوان"
                                       value={title}
                                       onChange={(val) => {
                                           setTitle(val.target.value)
                                       }}
                                />
                                <label htmlFor="floatingInput" className='text-small-2 right-0'>عنوان آدرس </label>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <div className="form-floating mb-3">
                                <input type="tel"
                                       className="form-control"
                                       id="floatingInput"
                                       placeholder="تماس"
                                       value={phone}
                                       onChange={(val) => {
                                           setPhone(val.target.value)
                                       }}
                                />
                                <label htmlFor="floatingInput" className='text-small-2 right-0'>شماره تماس </label>
                            </div>
                        </div>
                        <div className="col-8 mt-3">
                            <button className='w-100 btn btn-primary text-small-2'
                                    onClick={onSaveAddress}
                            >
                                ثبت آدرس
                            </button>
                        </div>
                        <div className="col-4 mt-3">
                            <button className='w-100 btn btn-secondary text-small-2'
                                    onClick={() => setHaveLocation(false)}

                            >
                                اصلاح موقعیت
                            </button>
                        </div>
                    </div>
                </section>
            }
            <section className="container-fluid  mt-1 py-4 rtl px-0  ">
                <div className="row ">

                    <div className="col-12 max-w-lg">


                        <MapContainer
                            center={center}
                            zoom={zoom}
                            scrollWheelZoom={true}
                            className='max-w-lg'
                            ref={setMap}

                        >
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Marker
                                position={[position.lat.toFixed(4), position.lng.toFixed(4)]}
                            >
                                <Popup>
                                    A pretty CSS3 popup. <br/> Easily customizable.
                                </Popup>
                            </Marker>
                        </MapContainer>


                    </div>
                </div>
                <div className="row">
                    <div className="col-12 p-2 fixed-bottom max-w-lg">
                        {
                            !haveLocation &&
                            <button
                                className="btn btn-primary text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                                onClick={onSetLocation}
                            >
                                تایید موقعیت روی نقشه
                                <span className="badge  p-2 float-start">
<TbCheck className='text-big-3'/>
                    </span>
                            </button>}
                    </div>
                </div>
            </section>


        </React.Fragment>
    );
}

export default AddAddress;